import {useEffect, useRef, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
  updateBannerConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'
import {getImageBaseUrl} from '../../../../../../utils/Utils'

const StoreSettingBannerPlugin = () => {
  const [notificationConfiguration, setNotificationConfiguration] = useState<any>([])
  const [selectedNotification, setSelectedNotification] = useState<any>({
    banner_link: '',
    is_banner_enabled: true,
  })
  const [isEdit, setIsEdit] = useState(false)
  const [indexOfEditEntry, setIndexOfEditEntry] = useState(0)
  const [configId, setConfigId] = useState(0)
  const [currentImageTempPath, setCurrentImageTempPath] = useState<any>('')
  const [file, setFile] = useState('')

  const hiddenFileInput = useRef<HTMLInputElement>(document.createElement('input'))

  useEffect(() => {
    getConfiguration()
  }, [])

  let baseImageUrl = getImageBaseUrl()

  const handleIconChange = (event: any) => {
    const fileUploaded = event.target.files[0]
    var tmpPath = URL.createObjectURL(event.target.files[0])
    setCurrentImageTempPath(tmpPath)
    setFile(fileUploaded)
  }

  const handleClick = () => {
    const fileInput = document.getElementById(`fileInput`)
    fileInput?.click()
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('store_setting_banner')

    if (result.success) {
      setNotificationConfiguration(result.data.values)
      setConfigId(result.data._id)
    }
  }

  const editConfiguration = async (index: any, isOpenNew: any) => {
    setIndexOfEditEntry(index)
    let banner_link = notificationConfiguration[index].banner_link
    let is_banner_enabled = notificationConfiguration[index].is_banner_enabled
    let imageUrl = notificationConfiguration[index].banner_image

    setSelectedNotification({
      banner_link: banner_link,
      is_banner_enabled: is_banner_enabled,
    })
    if (isOpenNew) {
      setIsEdit(true)
      setCurrentImageTempPath(`${baseImageUrl}/${imageUrl}`)
    }
  }

  const deleteConfiguration = async (index: any) => {
    let oldConfig = [...notificationConfiguration]
    oldConfig.splice(index, 1)

    let result = await updateConfigurationByConfigID(configId, oldConfig)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Deleted SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  const updateConfiguration = async (config: any) => {
    if (selectedNotification.banner_link.length !== 0) {
      let oldConfig = [...config]
      if (isEdit) {
        oldConfig.splice(indexOfEditEntry, 1)
      }

      selectedNotification.banner_id = notificationConfiguration.at(-1)?.banner_id || 0 + 1

      oldConfig.push(selectedNotification)

      let result = await updateBannerConfigurationByConfigID(configId, oldConfig, file)
      if (result.status == 200) {
        setSelectedNotification({
          banner_link: '',
          is_banner_enabled: true,
        })
        setCurrentImageTempPath('')
        setIsEdit(false)
        getConfiguration()
        ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
      } else {
        ErrorToastUtils()
      }
    } else {
      ToastUtils({type: 'error', message: 'Please Fill All Fields'})
    }
  }

  const updateEnabledConfiguration = async (index: any, value: any) => {
    let oldConfig = [...notificationConfiguration]
    oldConfig[index].is_banner_enabled = value
    setNotificationConfiguration(oldConfig)

    let result = await updateBannerConfigurationByConfigID(configId, oldConfig, file)
    if (result.status === 200) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  return (
    <div className='card'>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='row'>
            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>Banner Link</strong>
              </p>
            </div>
            <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
              <div className='flex'>
                <textarea
                  className='form-control'
                  name='policy'
                  value={selectedNotification.banner_link}
                  onChange={(event) =>
                    setSelectedNotification({
                      ...selectedNotification,
                      banner_link: event.target.value,
                    })
                  }
                  rows={10}
                  cols={60}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>Upload Image</strong>
              </p>
            </div>
            <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
              {currentImageTempPath.length === 0 ? (
                <>
                  <button className='btn btn-light' type='button' onClick={() => handleClick()}>
                    <i className='fa-solid fa-upload'></i>
                  </button>
                  <input
                    type='file'
                    name='icon'
                    id={`fileInput`}
                    onChange={(e) => handleIconChange(e)}
                    ref={hiddenFileInput}
                    style={{display: 'none'}}
                    accept='image/*'
                  />
                </>
              ) : (
                <div className='symbol symbol-70px overflow-visible me-3'>
                  <img
                    src={currentImageTempPath}
                    alt='Icon'
                    width='50px'
                    height='50px'
                    loading='lazy'
                  />

                  <button
                    onClick={() => {
                      setCurrentImageTempPath('')
                    }}
                    className='btn btn-danger btn-sm ms-8'
                  >
                    <i className='fa-solid fa-trash'></i>
                  </button>
                </div>
              )}
            </div>

            <div className='d-flex justify-content-end mt-4'>
              <button
                className='btn btn-primary'
                onClick={() => {
                  updateConfiguration(notificationConfiguration)
                }}
              >
                {isEdit ? 'Edit' : 'Save'}
              </button>
            </div>
          </div>
        </div>

        <div>
          <h2>Banner List</h2>
          <table className='table table-bordered table-responsive'>
            <thead>
              <tr>
                <th>Banner Link</th>
                <th>Image</th>
                <th>Is Enabled</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {notificationConfiguration.map((notification: any, index: any) => {
                return (
                  <tr key={index}>
                    <td>{notification.banner_link}</td>
                    <td>
                      <div className='symbol symbol-50px overflow-visible me-3'>
                        <img
                          src={`${baseImageUrl}/${notification?.banner_image}`}
                          alt='Icon'
                          width='50px'
                          height='50px'
                          loading='lazy'
                        />
                      </div>
                    </td>
                    <td>
                      <div className='form-check form-switch'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          role='switch'
                          id='flexSwitchCheckDefault'
                          name='is_banner_enabled'
                          checked={notification.is_banner_enabled}
                          onChange={(event) => {
                            updateEnabledConfiguration(index, event.target.checked)
                          }}
                        />
                      </div>
                    </td>
                    <td>
                      <button
                        className='ms-3 btn btn-secondary btn-sm'
                        onClick={() => editConfiguration(index, true)}
                      >
                        <i className='fa-regular fa-pen-to-square'></i>
                      </button>
                      <button
                        className='ms-3 btn btn-danger btn-sm'
                        onClick={() => deleteConfiguration(index)}
                      >
                        <i className='fa-solid fa-trash'></i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default StoreSettingBannerPlugin
